import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';

@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
    parse(value: string): NgbDateStruct | null {
        if (value) {
            const dateParts = value.trim().split('.');
            if (dateParts.length === 1 && parseInt(dateParts[0], 10)) {
                return { day: parseInt(dateParts[0], 10), month: -1, year: -1 };
            } else if (dateParts.length === 2 && parseInt(dateParts[0], 10) && parseInt(dateParts[1], 10)) {
                return { day: parseInt(dateParts[0], 10), month: parseInt(dateParts[1], 10), year: -1 };
            } else if (dateParts.length === 3 && parseInt(dateParts[0], 10) && parseInt(dateParts[1], 10) && parseInt(dateParts[2], 10)) {
                return { day: parseInt(dateParts[0], 10), month: parseInt(dateParts[1], 10), year: parseInt(dateParts[2], 10) };
            }
        }
        return null;
    }

    format(date: NgbDateStruct): string {
        return date ?
            `${Number.isInteger(date.day) ? this.padNumber(date.day) : ''}.${Number.isInteger(date.month) ? this.padNumber(date.month) : ''}.${date.year}` : '';
    }

    padNumber(n: number): string {
        return n > 9 ? n.toString() : `0${n}`;
    }
}
